import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FinancialHubComponent } from './financial-hub.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { PurchaseOrdersComponent } from './components/purchase-orders/purchase-orders.component';
import { PurchaseOrderDetailComponent } from './components/purchase-order-detail/purchase-order-detail.component';
import { PurchaseOrderViewComponent } from './components/purchase-order-view/purchase-order-view.component';
import { FinancialHubAccessGuard } from './guards/financial-hub-access.guard';

const TITLE_BAR_BASE = {
  title: 'Financial Hub',
  actions: []
};

const routes: Routes = [
  {
    path: '',
    component: FinancialHubComponent,
    canActivate: [FinancialHubAccessGuard],
    data: { ...TITLE_BAR_BASE, module: 'financial-hub' },
    children: [
      {
        path: '',
        redirectTo: 'purchase-orders',
        pathMatch: 'full'
      },
      {
        path: 'companies',
        component: CompaniesComponent,
        data: {
          ...TITLE_BAR_BASE,
          module: 'financial-hub/companies'
        }
      },
      {
        path: 'purchase-orders',
        component: PurchaseOrdersComponent,
        data: {
          ...TITLE_BAR_BASE,
          module: 'financial-hub/purchase-orders'
        }
      },
      {
        path: 'purchase-orders/create',
        component: PurchaseOrderDetailComponent,
        data: {
          ...TITLE_BAR_BASE,
          title: 'New purchase order',
          breadcrumbs: 'New purchase order',
          module: 'financial-hub/purchase-orders',
          mode: 'create'
        }
      },
      {
        // Must precede the :id route or Angular matches :id first and loads the view component.
        path: 'purchase-orders/:id/edit',
        component: PurchaseOrderDetailComponent,
        data: {
          ...TITLE_BAR_BASE,
          title: 'Edit purchase order',
          breadcrumbs: 'Edit purchase order',
          module: 'financial-hub/purchase-orders',
          mode: 'edit'
        }
      },
      {
        path: 'purchase-orders/:id',
        component: PurchaseOrderViewComponent,
        data: {
          ...TITLE_BAR_BASE,
          breadcrumbs: 'Purchase order detail',
          hideModuleTitle: true,
          module: 'financial-hub/purchase-orders'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinancialHubRoutingModule {}
